<template>
  <div>
    <SlickList
      v-model="list"
      @sort-start="$_onSortStart($event)"
      @sort-end="$_onSortEnd()"
    >
      <SlickItem
        v-for="(option, optionIndex) in list"
        :key="optionIndex"
        :index="optionIndex"
        :style="{'z-index': '10000'}"
        class="lv-sort-option-list__slick-item"
      >
        <LvTextCard class="pa-16">
          <template v-slot:content>
            <div class="lv-sort-option-list__wrap">
              <div class="lv-sort-option-list__item-wrap">
                <StateInputButton
                  :value="option.title"
                  disabled
                  required
                  rules="required"
                  class="lv-sort-option-list__item"
                  placeholder="名稱"
                />
                <DropdownMenuButton
                  v-if="!option.hasSubOption"
                  :value="option.risk"
                  outline
                  disabled
                  required
                  rules="required"
                  :dropdownMenuItem="riskItems"
                  class="lv-sort-option-list__item"
                  placeholder="風險等級"
                />
                <!-- <StateInputButton
                  v-if="!option.hasSubOption"
                  :value="option.score"
                  disabled
                  type="number"
                  widthIsPlaceholder
                  class="lv-sort-option-list__item"
                  placeholder="得分設定 (輸入數字)"
                /> -->
                <LvCheckbox
                  v-if="!option.hasSubOption"
                  h4
                  noWrap
                  disable
                  exclusive
                  text="選答時要求必填備註"
                  justifyContent="start"
                  :value="true"
                  :select="option.requiredRemark"
                  class="lv-sort-option-list__item"
                />
              </div>
              <LvText h3 blue class="lv-sort-option-list__icon"><i class="icon-drag" /></LvText>
            </div>
          </template>
        </LvTextCard>
        <SlickList
          v-if="((clicked === false && _sortIndex === null) || (clicked === true && _sortIndex !== null))
          && option.hasSubOption && option.subOptionList && option.subOptionList.length"
          v-model="option.subOptionList"
          class="mb-16"
        >
          <SlickItem
            v-for="(subOption, subOptionIndex) in option.subOptionList"
            :key="subOptionIndex"
            :index="subOptionIndex"
            :style="{'z-index': '10000'}"
            class="lv-sort-option-list__slick-item"
          >
            <div class="lv-sort-option-list__subOption-wrap">
              <LvTextCard class="lv-sort-option-list__subOption">
                <template v-slot:content>
                  <div class="lv-sort-option-list__wrap">
                    <div class="lv-sort-option-list__item-wrap">
                      <StateInputButton
                        :value="subOption.title"
                        disabled
                        required
                        rules="required"
                        class="lv-sort-option-list__item"
                        placeholder="名稱"
                      />
                      <DropdownMenuButton
                        :value="subOption.risk"
                        outline
                        disabled
                        required
                        rules="required"
                        :dropdownMenuItem="riskItems"
                        class="lv-sort-option-list__item"
                        placeholder="風險等級"
                      />
                      <!-- <StateInputButton
                        :value="subOption.score"
                        disabled
                        type="number"
                        widthIsPlaceholder
                        class="lv-sort-option-list__item"
                        placeholder="得分設定 (輸入數字)"
                      /> -->
                      <LvCheckbox
                        h4
                        noWrap
                        disable
                        exclusive
                        text="選答時要求必填備註"
                        justifyContent="start"
                        :value="true"
                        :select="subOption.requiredRemark"
                        class="lv-sort-option-list__item"
                      />
                    </div>
                    <LvText h3 blue class="lv-sort-option-list__icon"><i class="icon-drag" /></LvText>
                  </div>
                </template>
              </LvTextCard>
            </div>
          </SlickItem>
        </SlickList>
      </SlickItem>
    </SlickList>
    <LvFlexBox>
      <WsButton001
        red
        mediumButton
        leadingIcon="icon-close"
        class="mr-8"
        @click="$emit('cancel')"
      >
        {{ $t('取消') }}
      </WsButton001>
      <WsButton001
        mediumButton
        leadingIcon="icon-bih-check"
        @click="$_onSubmit()"
      >
        {{ $t('完成') }}
      </WsButton001>
    </LvFlexBox>
  </div>
</template>

<script>
import H_common from '@/helpers/common';
import Spare_checklist from '@/spare/checklist';
import { SlickList, SlickItem } from "vue-slicksort";

export default {
  components: {
    SlickList,
    SlickItem,
  },
  props: {
    originalList: {
      type: Array,
    }
  },
  data() {
    return {
      list: [],
      riskItems: Spare_checklist.riskItems,
      sortIndex: null,
      clicked: false,
    }
  },
  computed: {
    _sortIndex() {
      return this.sortIndex;
    }
  },
  mounted() {
    this.list = H_common.deepCopyFunction(this.originalList);
  },
  methods: {
    $_onSubmit() {
      this.$emit('input', this.list);
    },
    $_onSortStart($event) {
      this.sortIndex = $event.index;
      this.clicked = true;
    },
    $_onSortEnd() {
      this.sortIndex = null;
      this.clicked = false;
    },
  }
}
</script>